import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import ClearScreensButton from "../buttons/toolbar/ClearScreensButton";
import OnairToggleButton from "../buttons/toolbar/OnairToggleButton";
import SelectedScreenButton from "../buttons/toolbar/SelectedScreenButton";

const SelectedScreensShortcutBar = () => {
  const rootStore = useContext(RootStoreContext);
  const { isToShowToolbarScreens, selectedScreens } = rootStore.screensStore;

  return (
    <>
      {isToShowToolbarScreens ? (
        selectedScreens.map((s) => (
          <div key={s.id} className="ml-2 divButton">
            <SelectedScreenButton screen={s} />
          </div>
        ))
      ) : (
        <></>
      )}
      <div className="ml-2 divButton">
        <OnairToggleButton />
      </div>
      <div className="ml-2 divButton position-relative">
        <ClearScreensButton />
      </div>
    </>
  );
};

export default observer(SelectedScreensShortcutBar);
